"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var users = exports.users = { "viewBox": "0 0 24 24", "children": [{ "name": "path", "attribs": { "d": "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }, "children": [] }, { "name": "circle", "attribs": { "cx": "9", "cy": "7", "r": "4" }, "children": [] }, { "name": "path", "attribs": { "d": "M23 21v-2a4 4 0 0 0-3-3.87" }, "children": [] }, { "name": "path", "attribs": { "d": "M16 3.13a4 4 0 0 1 0 7.75" }, "children": [] }], "attribs": { "fill": "none", "stroke": "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" } };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/feather/users.js
// module id = 752
// module chunks = 1